/**
 * Remover acentos
 * @param value string
 */
export function normalizeString(value: string): string {
  return value
    .normalize('NFD') // separa letras dos acentos
    .replace(/[\u0300-\u036f]/g, '') // remove os acentos
    .toLowerCase();
}
